import { BigCommerceLogotype } from '@/lib/seo/constants'

export const NewsArticleMarkupContent = (
	url: string,
	headline: string,
	articleBody: string,
	publishedDate: string
) => {
	const jsonLdData = {
		'@context': 'https://schema.org',
		'@type': 'NewsArticle',
		url: url,
		publisher: {
			'@type': 'Organization',
			name: 'BigCommerce',
			logo: BigCommerceLogotype
		},
		headline: headline,
		mainEntityOfPage: url,
		articleBody: articleBody,
		image: [BigCommerceLogotype],
		datePublished: publishedDate
	}

	return JSON.stringify(jsonLdData)
}
